import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaPhone, FaFax, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import client from '../../sanityClient';
import { tandaraDetailsQuery } from '../../queries';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.secondary};
  color: white;
  padding: 3rem 0 1.5rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  margin-bottom: 1.5rem;
`;

const FooterTitle = styled.h3`
  color: white;
  font-size: 1.25rem;
  margin-bottom: 1.25rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -0.5rem;
    width: 50px;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;

const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.8);
  display: block;
  margin-bottom: 0.75rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: white;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.8);
`;

const ContactIcon = styled.span`
  margin-right: 0.75rem;
  color: ${({ theme }) => theme.colors.accent};
`;

const ContactLink = styled.a`
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s ease;
  
  &:hover {
    color: white;
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 1.5rem;
  margin-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [tandaraDetailsData, setTandaraDetailsData] = useState(null);

  useEffect(() => {
    client.fetch(tandaraDetailsQuery)
      .then((data) => {
        setTandaraDetailsData(data);
      })
      .catch(console.error);
  }, []);
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Tandara Lodge</FooterTitle>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', marginBottom: '1rem' }}>
            Providing a high standard of care and quality of life for those who choose to use our services.
          </p>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Quick Links</FooterTitle>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/services">Services</FooterLink>
          <FooterLink to="/fees">Fees & Charges</FooterLink>
          <FooterLink to="/news">News & Events</FooterLink>
          <FooterLink to="/policies">Policies</FooterLink>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Contact Us</FooterTitle>
          <ContactItem>
            <ContactIcon>
              <FaMapMarkerAlt />
            </ContactIcon>
            <div>
              {tandaraDetailsData ? tandaraDetailsData.streetAddress : "10 Nightingale Avenue, Sheffield, Tasmania 7306"}
            </div>
          </ContactItem>
          
          <ContactItem>
            <ContactIcon>
              <FaPhone />
            </ContactIcon>
            <ContactLink href={`tel:${tandaraDetailsData ? tandaraDetailsData.phoneNumber : '0364911277'}`}>
              {tandaraDetailsData ? tandaraDetailsData.phoneNumber : '03 6491 1277'}
            </ContactLink>
          </ContactItem>
          
          <ContactItem>
            <ContactIcon>
              <FaFax />
            </ContactIcon>
            <div>{tandaraDetailsData ? tandaraDetailsData.faxNumber : '03 6491 2527'}</div>
          </ContactItem>
          
          <ContactItem>
            <ContactIcon>
              <FaEnvelope />
            </ContactIcon>
            <ContactLink href={`mailto:${tandaraDetailsData ? tandaraDetailsData.emailAddress : 'admin@tandara.net.au'}`}>
              {tandaraDetailsData ? tandaraDetailsData.emailAddress : 'admin@tandara.net.au'}
            </ContactLink>
          </ContactItem>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        &copy; {currentYear} Tandara Lodge Community Care Inc. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
